<div class="container">
    <div class="globalbwert">
        <span multilang class="cc2">HolidayCheck Bewertungen:</span>
        <div class="cont">
            <span multilang class="title">{{title}}</span>
            <div class="hcheckbtnwrp">
                <div class="reatingico">
                    <mat-icon class="reatingicomat-ico">
                        thumb_up_alt</mat-icon>
                    @if(data?.rating?.recommendation) {
                    <span multilang>{{data?.rating.recommendation}}%</span>
                    }
                </div>
                <div class="hcheck">
                    <img loading="lazy" src="assets/images/holidaycheck.svg" width="auto" height="25px"
                        alt="holidaycheck">
                </div>
            </div>
        </div>
        <div class="bwr">
            <div class="bwrttop" *ngIf="overall.length > 0">
                <span multilang class="elips">GESAMTBEWERTUNG</span>
                <div class="cc3">
                    <div class="cc4">
                        @for(bw of overall;track $index){
                        @if($index< 6 ){ <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                            }
                            }
                    </div>
                    <div class="cc5">
                        {{data.rating?.overall * 6 / 100 | number :'1.1-1'}}
                    </div>
                </div>
            </div>
            <div class="bwrttop" *ngIf="food.length > 0">
                <span multilang>GASTRONOMIE</span>
                <div class="cc3">
                    <div class="cc4">
                        @for(bw of food;track $index){
                        @if($index< 6 ){ <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                            }
                            }
                    </div>
                    <div class="cc5">
                        {{data.rating?.food * 6 / 100 | number :'1.1-1'}}
                    </div>
                </div>
            </div>
            <div class="bwrttop" *ngIf="hotel.length > 0">
                <span multilang>HOTEL</span>
                <div class="cc3">
                    <div class="cc4">
                        @for(bw of hotel;track $index){
                        @if($index< 6 ){ <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                            }
                            }
                    </div>
                    <div class="cc5">
                        {{data.rating?.hotel * 6 / 100 | number :'1.1-1'}}
                    </div>
                </div>
            </div>
            <div class="bwrttop" *ngIf="leisure.length > 0">
                <span multilang class="elips">SPORT UND UNTERH.</span>
                <div class="cc3">
                    <div class="cc4">
                        @for(bw of leisure;track $index){
                        @if($index< 6 ){ <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                            }
                            }
                    </div>
                    <div class="cc5">
                        {{data.rating?.leisure * 6 / 100 | number :'1.1-1'}}
                    </div>
                </div>
            </div>
            <div class="bwrttop" *ngIf="location.length > 0">
                <span multilang>LAGE</span>
                <div class="cc3">
                    <div class="cc4">
                        @for(bw of location;track $index){
                        @if($index< 6 ){ <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                            }
                            }
                    </div>
                    <div class="cc5">
                        {{data.rating?.location * 6 / 100 | number :'1.1-1'}}
                    </div>
                </div>
            </div>
            <div class="bwrttop" *ngIf="room.length > 0">
                <span multilang>ZIMMER</span>
                <div class="cc3">
                    <div class="cc4">
                        @for(bw of room;track $index){
                        @if($index< 6 ){ <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                            }
                            }
                    </div>
                    <div class="cc5">
                        {{data.rating?.room * 6 / 100 | number :'1.1-1'}}
                    </div>
                </div>
            </div>
            <div class="bwrttop" *ngIf="service.length > 0">
                <span multilang>SERVICE</span>
                <div class="cc3">
                    <div class="cc4">
                        @for(bw of service;track $index){
                        @if($index< 6 ){ <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">wb_sunny</mat-icon>
                            }
                            }
                    </div>
                    <div class="cc5">
                        {{data.rating?.service * 6 / 100 | number :'1.1-1'}}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="rev-cont">
        <div style="width:100%" *ngFor="let review of datas?.hotelReviewList">
            <div class="cc6">
                <div class="flc">
                    <div class="cc7">
                        <!--Title of review-->
                        <!-- <span multilang class="cc8">
                            "{{review?.title}}"
                        </span> -->



                        <!--Autor review-->
                        <span multilang class="cc10"
                            style="color:var(--coraldarkgrey);font-size:1rem;font-weight: 500;">
                            {{review.author ?
                            review.author :
                            'Anonym'}}
                            {{review.age ? ' (' +
                            review.age + ')' : ''}}
                        </span>

                        <!--Sub Autor text-->
                        <span multilang style="font-size:12px;font-weight: 500;color:var(--coralgrey)">
                            Verreist als {{review.travelCompaniontext}} - {{review.travelDate | date:'MMM yyyy'}}
                        </span>
                    </div>
                    <div class="starss">
                        <div class="cc4">
                            @for(bw of review.overall;track $index){
                            @if($index< 5){ <mat-icon [class.ac]="bw === 1" [class.nac]="bw === 0">
                                star</mat-icon>
                                }
                                }
                        </div>
                    </div>
                </div>




                <div class="perswrp" *ngIf="review?.overall?.length > 0">
                    <span multilang class="cc11"
                        style="font-size: 12px;font-weight: 400;color:#505151;">{{review.text}}</span>
                </div>

                <div style="margin-top:1rem;">
                    <div class="perswrp" *ngIf="review?.food?.length > 0">
                        <div class="bwrttop" style="height:15px;font-weight:500;font-size:14px">
                            <span multilang>GASTRONOMIE</span>
                            <div class="cc3" style="width:50px">
                                <mat-icon class="ac">star</mat-icon>
                                <div class="cc5" style="margin-left:0.3rem">
                                    {{review.rating?.food * 6 / 100 | number :'1.1-1'}}
                                </div>
                            </div>
                        </div>
                        <span multilang class="cc11"
                            style="font-size: 12px;font-weight: 400;color:#505151;">{{review.textFood}}</span>
                    </div>
                    <div class="perswrp" *ngIf="review?.hotel?.length > 0">
                        <div class="bwrttop" style="height:15px;font-weight:500;font-size:14px">
                            <span multilang>HOTEL</span>
                            <div class="cc3" style="width:50px">
                                <mat-icon class="ac">star</mat-icon>
                                <div class="cc5" style="margin-left:0.3rem">
                                    {{review.rating?.hotel * 6 / 100 | number :'1.1-1'}}
                                </div>
                            </div>
                        </div>
                        <span multilang class="cc11"
                            style="font-size: 12px;font-weight: 400;color:#505151;">{{review.textHotel}}</span>
                    </div>
                    <div class="perswrp" *ngIf="review?.leisure?.length > 0">
                        <div class="bwrttop" style="height:15px;font-weight:500;font-size:14px">
                            <span multilang>SPORT UND UNTERH.</span>
                            <div class="cc3" style="width:50px">
                                <mat-icon class="ac">star</mat-icon>
                                <div class="cc5" style="margin-left:0.3rem">
                                    {{review.rating?.leisure * 6 / 100 | number :'1.1-1'}}
                                </div>
                            </div>
                        </div>
                        <span multilang class="cc11"
                            style="font-size: 12px;font-weight: 400;color:#505151;">{{review.textSports}}</span>
                    </div>
                    <div class="perswrp" *ngIf="review?.location?.length > 0">
                        <div class="bwrttop" style="height:15px;font-weight:500;font-size:14px">
                            <span multilang>LAGE</span>
                            <div class="cc3" style="width:50px">
                                <mat-icon class="ac">star</mat-icon>
                                <div class="cc5" style="margin-left:0.3rem">
                                    {{review.rating?.location * 6 / 100 | number :'1.1-1'}}
                                </div>
                            </div>
                        </div>
                        <span multilang class="cc11"
                            style="font-size: 12px;font-weight: 400;color:#505151;">{{review.textLocation}}</span>
                    </div>
                    <div class="perswrp" *ngIf="review?.room?.length > 0">
                        <div class="bwrttop" style="height:15px;font-weight:500;font-size:14px">
                            <span multilang>ZIMMER</span>
                            <div class="cc3" style="width:50px">
                                <mat-icon class="ac">star</mat-icon>
                                <div class="cc5" style="margin-left:0.3rem">
                                    {{review.rating?.room * 6 / 100 | number :'1.1-1'}}
                                </div>
                            </div>
                        </div>
                        <span multilang class="cc11"
                            style="font-size: 12px;font-weight: 400;color:#505151;">{{review.textRoom}}</span>
                    </div>
                    <div class="perswrp" *ngIf="review?.service?.length > 0">
                        <div class="bwrttop" style="height:15px;font-weight:500;font-size:14px">
                            <span multilang>SERVICE</span>
                            <div class="cc3" style="width:50px">
                                <mat-icon class="ac">star</mat-icon>
                                <div class="cc5" style="margin-left:0.3rem">
                                    {{review.rating?.service * 6 / 100 | number :'1.1-1'}}
                                </div>
                            </div>
                        </div>
                        <span multilang class="cc11"
                            style="font-size: 12px;font-weight: 400;color:#505151;">{{review.textService}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>